import { TimerState } from "../states/timer";
import { ITimer } from "../../models/timer";
import { ETimerActions, TimerActions } from "../actions/timer";

export function TimerReducers(
  state: ITimer = TimerState,
  action: TimerActions,
): ITimer {
  switch (action.type) {
    case ETimerActions.TimerOn: {
      return {
        ...state,
        serverTime: action.payload.serverTime,
      };
    }
    default:
      return state;
  }
}
